// extracted by mini-css-extract-plugin
export default {"header":"header___EPamZep","filters":"filters___EPamZep","langSelect":"langSelect___EPamZep","compareRow":"compareRow___EPamZep"};